module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipe"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "swipeList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "homeContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "shareContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "downloadContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-624803b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 164
// module chunks = 1